import { useState } from "react";
import { hotFeed } from "@/mocks/chigua";

const filters = ["全部", "剧组路透", "综艺现场", "红毯前线", "音乐现场", "片场日记", "素人暖闻"];

export default function HotFeed() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? hotFeed : hotFeed.filter((h) => h.tag === active);
  const featured = list[0];
  const rest = list.slice(1);

  return (
    <section id="hot" className="relative bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-medium tracking-widest text-primary-500">DAILY MELONS</p>
            <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
              今日<span className="text-primary-500">热瓜</span>流
            </h2>
            <p className="mt-2 text-sm text-foreground-600">围观群众实时更新的新鲜瓜田，看看大家今天都在吃什么瓜。</p>
          </div>
          <div className="no-scrollbar -mx-1 flex gap-1 overflow-x-auto rounded-full p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                  active === f
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {featured && (
          <article className="mt-8 grid gap-6 overflow-hidden rounded-3xl border border-background-200 bg-background-100 lg:grid-cols-2">
            <div className="relative h-64 lg:h-full">
              <img
                src={featured.image}
                alt={featured.title}
                className="h-full w-full object-cover object-center"
              />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                精选 · {featured.tag}
              </span>
            </div>
            <div className="flex flex-col justify-center p-6 md:p-9">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-time-line"></i>
                <span>{featured.time}</span>
                <span className="text-foreground-200">·</span>
                <span>{featured.views} 浏览</span>
                <span className="text-foreground-200">·</span>
                <span>{featured.comments} 讨论</span>
              </div>
              <h3 className="mt-3 font-display text-2xl leading-snug text-foreground-950 md:text-3xl">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">{featured.excerpt}</p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-notification-2-line"></i>蹲一个后续
                </button>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className="ri-chat-3-line"></i>围观讨论
                </button>
              </div>
            </div>
          </article>
        )}

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((h) => (
            <article
              key={h.id}
              className="group flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition-shadow hover:shadow-[0_10px_30px_rgba(224,74,65,0.08)]"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={h.image}
                  alt={h.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-600 backdrop-blur">
                  {h.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  <span>{h.time}</span>
                </div>
                <h3 className="mt-2 font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {h.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{h.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {h.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-1-line"></i>
                    {h.comments}
                  </span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 rounded-full px-2 py-1 font-medium text-primary-600 transition-colors hover:bg-primary-50"
                  >
                    蹲后续 <i className="ri-arrow-right-line text-xs"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}